import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
import App from './App';
import './styles/themes.css';
import './i18n';

function hideSplash() {
  const el = document.getElementById('splash-screen');
  if (el) {
    el.classList.add('fade-out');
    setTimeout(() => el.remove(), 600);
  }
}

async function initMobile() {
  const { Capacitor } = await import('@capacitor/core');
  if (!Capacitor.isNativePlatform()) return;

  const { App: CapacitorApp } = await import('@capacitor/app');
  const { SplashScreen } = await import('@capacitor/splash-screen');
  const { StatusBar, Style } = await import('@capacitor/status-bar');

  await StatusBar.setStyle({ style: Style.Dark });
  await StatusBar.setBackgroundColor({ color: '#FF6B35' });
  setTimeout(() => SplashScreen.hide(), 3000);

  const appStateHandle = CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    console.log('App state changed. Is active:', isActive);
  });

  const backButtonHandle = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack) {
      CapacitorApp.exitApp();
    } else {
      window.history.back();
    }
  });

  return () => {
    appStateHandle.then(h => h.remove());
    backButtonHandle.then(h => h.remove());
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

setTimeout(hideSplash, 3000);
initMobile().catch(console.error);
